import { create } from "zustand"

/** The People list's current order, so a person page can step to its neighbours. */
export const usePeopleOrder = create<{ ids: readonly string[] }>()(() => ({
	ids: [],
}))

export function neighboursOf(ids: readonly string[], id: string) {
	const index = ids.indexOf(id)
	if (index === -1) return { nextId: null, previousId: null }
	return {
		nextId: ids[index + 1] ?? null,
		previousId: index > 0 ? (ids[index - 1] ?? null) : null,
	}
}
